import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import ContactHead from '../Contact/ContactHead';
import CuisineStart from '../cuisine/CuisineStart';
import CuisineTreat from '../cuisine/CuisineTreat';
import CuisineFresh from '../cuisine/CuisineFresh';

const imageHead = {
  title: 'Gourmet Retreat at the Flavourful <br/>Ice and Spice Restaurant',
  image: "../image/cuisine-banner.webp",
  breadcrumb: [
    {
      slug: "/resort-de-coracao-goa",
      name: "Goa",
    },
    {
      name: "Dining",
    },
  ]
}

const quoteHead = {
  desc: "Dining at De Coração is about savoring great food and the accompanying feel-good atmosphere. At our signature restaurant, Ice and Spice, we offer an all-inclusive dining experience featuring a menu of world cuisines and regional favorites. Whether indoors or al-fresco, enjoy a calming ambiance, gentle music, and personalized service that makes every guest feel at home.",
  title: "An Overview",
};

const startData = {
  title: "A delicious start: our alpine-Mediterranean breakfast",
  timing: "Daily from 7:30 am to 11:00 am",
  desc: "<p>Gentle morning sun and fresh air welcome you to a serene breakfast experience at De Coração. Start your day with coffee aromas, freshly baked bread, regional delicacies, homemade spreads, and rich egg preparations on the sun terrace. Enjoy an Alpine-Mediterranean-inspired spread while relaxing with panoramic views and peaceful anticipation of the beautiful day ahead.</p>",
  topLeftImg: "/image/cuisine-start-1.webp",
  topRightImg: '/image/cuisine-start-2.webp',
  bottomImg: "/image/cuisine-start-3.webp",
}

const treatData = {
  leftImg: "/image/cuisine-treat-1.webp",
  rightImg: "/image/cuisine-treat-2.webp",
  title: "For a little treat between meals",
  desc: `<p><label>From 12:00 pm to 2:00 pm,</label> you can order delicious specialities from our gourmet menu (for an additional charge). If you're out exploring and return to the hotel in the afternoon, or suddenly crave something sweet, from <label>from 2:30 pm</label> onwards, a buffet with the finest cakes awaits you. This is included in your pampering board.</p>
  <p><label>Throughout the day,</label> our bar also serves refreshing drinks, both alcoholic and non-alcoholic.</p>`
}

const diningData = {
  title: "Evening gourmet dining at De Coração.",
  timing: "Daily from 6:30 pm.",
  desc: `<p>After a day full of experiences, unwind with a relaxed gourmet dinner at De Coração’s open-air restaurant and outdoor kitchen. Enjoy a specially crafted 5-course menu with thoughtfully prepared side dishes, explore our culinary events, and discover selections from our curated wine collection, all complemented by the serene charm of the beach.</p>
  <p>End your evening with a glass of our <label>Special Wine</label> in the warm and inviting fireplace lounge.</p>`,
  topLeftImg: "/image/cuisine-dining-1.webp",
  topRightImg: '/image/cuisine-dining-2.webp',
  bottomImg: "/image/cuisine-dining-3.webp",
}

const freshData = [
  {
    img: "/image/cuisine-fresh-1.webp",
    title: "Fresh Sourcing",
    desc: "Locally sourced produce for authentic flavors."
  },
  {
    img: "/image/cuisine-fresh-2.webp",
    title: "Gourmet Dining",
    desc: "Carefully crafted multi-course culinary experiences."
  },
  {
    img: "/image/cuisine-fresh-3.webp",
    title: "Diverse Cuisine",
    desc: "Variety of regional and international flavors."
  },
  {
    img: "/image/cuisine-fresh-4.webp",
    title: "Cozy Ambience",
    desc: "Warm and relaxing dining atmosphere."
  }
];


const signData = {
  leftImg: "/image/cuisine-sign-1.webp",
  rightImg: "/image/goa-cuisine-sign-2.webp",
  title: "Signature Dinner Experience",
  desc: `<p>Celebrate memorable moments with a <label>Specially Curated Dinner</label> at De Coração. Delight in exquisite flavors prepared with care, featuring thoughtfully crafted dishes and a variety of culinary choices to suit every palate.</p>
  <p>Enjoy a cozy and elegant ambiance that enhances your dining experience, creating the perfect setting for relaxation, connection, and unforgettable moments with family and friends.</p>`
}

export default function CuisineGoa() {
  return (
    <>
      <ImageHeader imageHead={imageHead} />
      <ContactHead quoteHead={quoteHead} />
      <CuisineStart data={startData} headingTag="h1"/>
      <CuisineTreat data={treatData} headingTag="h2"/>
      <CuisineStart data={diningData} headingTag="h3"/>
      <CuisineFresh freshData={freshData} />
      <CuisineTreat data={signData} headingTag="h4"/>
    </>
  )
}
